import format from 'string-template';
import { messages } from '../translations/message';
import * as utils from '../translations/utils/';
import { getUserFromLocalStorage } from '../component/utils/user';

export const getMessage = (key) => {
  const localUser = getUserFromLocalStorage();
  // let language = utils.getLocalLanguage();
  let language = localUser.language.toLowerCase();
  if (language.startsWith('en-')) {
    language = 'en';
  } else if (language.startsWith('sp')) {
    // Map 'sp' to 'es'
    language = 'es';
  } else if (language.includes('-')) {
    // For other languages, use only the primary language subtag
    language = language.split('-')[0];
  }
  return messages[language] && messages[language][key]; 

};